import { render, staticRenderFns } from "./JiraQaImportCreate.vue?vue&type=template&id=7ad7481b&scoped=true"
import script from "./JiraQaImportCreate.vue?vue&type=script&lang=js"
export * from "./JiraQaImportCreate.vue?vue&type=script&lang=js"
import style0 from "./JiraQaImportCreate.vue?vue&type=style&index=0&id=7ad7481b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad7481b",
  null
  
)

export default component.exports